/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Settle_ChoiceInputs */

const en_inbound_settle_choice = /** @type {(inputs: Inbound_Settle_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The supplier's choice`)
};

/**
* | output |
* | --- |
* | "The supplier's choice" |
*
* @param {Inbound_Settle_ChoiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_settle_choice = /** @type {((inputs?: Inbound_Settle_ChoiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Settle_ChoiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_settle_choice(inputs)
});